export default __webpack_public_path__ + "static/media/el19.8e94220e.svg";